import { render, staticRenderFns } from "./ProjectEvalCard.vue?vue&type=template&id=8e9ddf12&scoped=true"
import script from "./ProjectEvalCard.vue?vue&type=script&lang=js"
export * from "./ProjectEvalCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectEvalCard.vue?vue&type=style&index=0&id=8e9ddf12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9ddf12",
  null
  
)

export default component.exports